import clsx from "clsx";
import * as React from "react";

type HTMLProps = React.HTMLProps<HTMLDivElement>;
type SVGProps = React.SVGProps<SVGSVGElement>;

interface LoaderProps extends HTMLProps {
  variant?: "text" | "line" | "dots" | "spinner";
  color?: "red" | "white" | "blue";
}

const Loader = React.forwardRef<HTMLDivElement, LoaderProps>(
  ({ variant = "text", color = "red", className, ...props }, ref) => {
    const divProps = props as HTMLProps;
    const svgProps = props as SVGProps;

    return (
      <React.Fragment>
        {variant === "spinner" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={40}
            height={40}
            viewBox="0 0 24 24"
            {...svgProps}
          >
            <g
              stroke={
                color === "red"
                  ? "var(--accent-primary)"
                  : color === "blue"
                    ? "var(--accent-secondary)"
                    : "var(--one-x-white)"
              }
            >
              <circle
                cx={12}
                cy={12}
                r={9.5}
                fill="none"
                strokeLinecap="round"
                strokeWidth={1.5}
              >
                <animate
                  attributeName="stroke-dasharray"
                  calcMode="spline"
                  dur="1.5s"
                  keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                  keyTimes="0;0.475;0.95;1"
                  repeatCount="indefinite"
                  values="0 150;42 150;42 150;42 150"
                ></animate>
                <animate
                  attributeName="stroke-dashoffset"
                  calcMode="spline"
                  dur="1.5s"
                  keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                  keyTimes="0;0.475;0.95;1"
                  repeatCount="indefinite"
                  values="0;-16;-59;-59"
                ></animate>
              </circle>
              <animateTransform
                attributeName="transform"
                dur="2s"
                repeatCount="indefinite"
                type="rotate"
                values="0 12 12;360 12 12"
              ></animateTransform>
            </g>
          </svg>
        ) : (
          <div
            ref={ref}
            data-variant={variant}
            data-color={color}
            className={clsx("ox-reset ox-Loader", className)}
            {...divProps}
          />
        )}
      </React.Fragment>
    );
  },
);

Loader.displayName = "Loader";
export { Loader };
export type { LoaderProps };
